import { useIntl } from 'react-intl';
import * as Styled from './LoginPage.styled';
import { ExternalLoginPanel } from './ExternalLoginPanel';

interface OidcLoginPanelProps {
  readonly returnTo?: string;
  readonly oidcProviderName: string;
}

export const OidcLoginPanel = ({ returnTo, oidcProviderName }: OidcLoginPanelProps) => {
  const intl = useIntl();
  const href = returnTo ? `/oauth/login?returnTo=${returnTo}` : '/oauth/login';
  const description = intl.formatMessage(
    {
      id: 'oidcSignInDescription',
      defaultMessage:
        "Click the button below to sign in with {providerName} credentials. You'll be redirected to {providerName} login screen, and returned to Medallia Ideas after successfully signing in there."
    },
    { providerName: oidcProviderName }
  );

  return (
    <ExternalLoginPanel panelId="OpenIDSSOlogin" description={description}>
      <Styled.LoginLink href={href}>{intl.formatMessage({ id: 'signIn', defaultMessage: 'Sign in' })}</Styled.LoginLink>
    </ExternalLoginPanel>
  );
};
